(() => {
  if (window.PawprintFullIngredients) {
    window.PawprintFullIngredients.init(document);
    return;
  }
  const initialized = new WeakSet();
  function setup(section) {
    if (initialized.has(section)) return;
    initialized.add(section);
    const tabs = [...section.querySelectorAll('[data-full-formula-tab]')];
    const panels = [...section.querySelectorAll('[data-full-formula-panel]')];
    function select(tab, focus = false) {
      const species = tab.dataset.fullFormulaTab;
      tabs.forEach(candidate => {
        const selected = candidate === tab;
        candidate.setAttribute('aria-selected', String(selected));
        candidate.tabIndex = selected ? 0 : -1;
      });
      panels.forEach(panel => { panel.hidden = panel.dataset.fullFormulaPanel !== species; });
      if (focus) tab.focus();
    }
    tabs.forEach((tab, index) => {
      tab.addEventListener('click', () => select(tab));
      tab.addEventListener('keydown', event => {
        let target;
        if (event.key === 'ArrowRight') target = tabs[(index + 1) % tabs.length];
        if (event.key === 'ArrowLeft') target = tabs[(index + tabs.length - 1) % tabs.length];
        if (event.key === 'Home') target = tabs[0];
        if (event.key === 'End') target = tabs[tabs.length - 1];
        if (target) { event.preventDefault(); select(target, true); }
      });
    });
    section.querySelectorAll('[data-full-formula-disclosure]').forEach(details => {
      const summary = details.querySelector('summary');
      const update = () => summary.setAttribute('aria-expanded', String(details.open));
      update();
      details.addEventListener('toggle', update);
    });
    const tablist = section.querySelector('[data-full-formula-tablist]');
    if (tabs.length && tablist) {
      select(tabs.find(tab => tab.getAttribute('aria-selected') === 'true') || tabs[0]);
      section.setAttribute('data-full-formulas-ready', '');
      tablist.hidden = false;
    }
    section.addEventListener('shopify:block:select', event => {
      const card = event.target.closest('[data-full-formula-card]');
      if (!card || !section.contains(card)) return;
      const panel = card.closest('[data-full-formula-panel]');
      const tab = tabs.find(candidate => candidate.dataset.fullFormulaTab === panel.dataset.fullFormulaPanel);
      if (tab) select(tab);
      const details = card.querySelector('[data-full-formula-disclosure]');
      if (details) details.open = true;
    });
  }
  function init(scope) {
    if (scope.matches?.('[data-full-formulas]')) setup(scope);
    scope.querySelectorAll?.('[data-full-formulas]').forEach(setup);
  }
  window.PawprintFullIngredients = { init };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init(document), { once: true });
  else init(document);
  document.addEventListener('shopify:section:load', event => init(event.target));
})();
